<template>
    <button v-t="'crud:button.save'" type="submit" class="btn btn-primary"></button>
</template>
